import React, { createContext, useContext, useState, useEffect, useCallback } from 'react'

const AuthContext = createContext(null)

const ADMIN_PASSWORD = 'biometal-intake-2024' // In production, use proper auth with hashed passwords

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('admin_token')
    if (token === 'biometal-admin-verified') {
      setIsAuthenticated(true)
    }
    setLoading(false)
  }, [])

  const login = useCallback((password) => {
    if (password === ADMIN_PASSWORD) {
      localStorage.setItem('admin_token', 'biometal-admin-verified')
      setIsAuthenticated(true)
      return true
    }
    return false
  }, [])

  const logout = useCallback(() => {
    localStorage.removeItem('admin_token')
    setIsAuthenticated(false)
  }, [])

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}